import jsPDF from "jspdf";
import "jspdf-autotable";
import * as htmlToImage from "html-to-image";
import moment from "moment"; // Import moment library
import * as XLSX from "xlsx";

export async function exportMultipleChartsToPdf(name, tableData1, tableData2) {
  const doc = new jsPDF("p", "px");

  const elements = document.getElementsByClassName("custom-chart");

  await createPdf({ doc, elements, tableData1, tableData2 });

  doc.save(`Metaverse_${name}_Report_${moment().format("MMMM Do YYYY, h:mm:ss a")}.pdf`);
}

async function createPdf({ doc, elements, tableData1, tableData2 }) {
  const padding = 10;
  const marginTop = 20;
  let top = marginTop;

  addTable(doc, tableData1, top);

  top += calculateTableHeight(tableData1) + marginTop;

  for (let i = 0; i < elements?.length; i++) {
    const el = elements?.item(i);
    const imgData = await htmlToImage.toPng(el, { quality: 1.0, pixelRatio: 2 });

    let elHeight = el.offsetHeight;
    let elWidth = el.offsetWidth;

    const pageWidth = doc.internal.pageSize.getWidth();

    if (elWidth > pageWidth) {
      const ratio = pageWidth / elWidth;
      elHeight = elHeight * ratio - padding * 2;
      elWidth = elWidth * ratio - padding * 2;
    }

    const pageHeight = doc.internal.pageSize.getHeight();

    if (top + elHeight > pageHeight) {
      doc.addPage();
      top = marginTop;
    }

    const xPosition = (pageWidth - elWidth) / 2;

    doc.addImage(imgData, "PNG", xPosition, top, elWidth, elHeight, `image${i}`);
    top += elHeight + marginTop;
  }

  if (tableData2) {
    addTable(doc, tableData2, top);
  }
}
function addTableHeading(doc, startY) {
  doc.autoTable({
    startY,
    head: [["My Dashboard"]],
  });
}

function addTable(doc, tableData, startY) {
  doc.autoTable({
    startY,
    head: [tableData[0]],
    body: tableData.slice(1),
  });
}

function calculateTableHeight(tableData) {
  const rowHeight = 20;
  return (tableData.length - 1) * rowHeight;
}

export const generateExcel = (name, tableData1, tableData2) => {
  const workbook = XLSX.utils.book_new();
  const combinedData = [...tableData1, ...tableData2];
  const worksheet = XLSX.utils.aoa_to_sheet(combinedData);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `Metaverse_report_${name}_${moment().format("MMMM Do YYYY, h:mm:ss a")}.xlsx`);
};
